import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@linaria/react';
import { ShinyBorderCard } from '../../components/ShinyBorderCard';
import dynamic from 'next/dynamic';
import { PrimaryLinkButton3Resume } from '../../components/StylesThings';
import { PDFDownloadButtonBorder } from './PDFDownloadButtonBorder';
import "./components.linaria.module.css!=!./components?./components.linaria.module.css?css=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"
export const GalaxyBackgroundLazyLoaded = dynamic(() => import('./background').then(mod => mod.default));
export const PageWrapper = /*#__PURE__*/styled('main')({
  name: "PageWrapper",
  class: "p1n9p43y",
  propsAsIs: false
});
export const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c1a8f9kp",
  propsAsIs: false
});
export const Header = /*#__PURE__*/styled('div')({
  name: "Header",
  class: "h33dz8a",
  propsAsIs: false
});
export const Title = /*#__PURE__*/styled('h1')({
  name: "Title",
  class: "tz8bd7",
  propsAsIs: false
});
export const Subtitle = /*#__PURE__*/styled('p')({
  name: "Subtitle",
  class: "swm8sxz",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ShinyBorderCard;
export const Content = /*#__PURE__*/styled(_exp3())({
  name: "Content",
  class: "c6j8fo3",
  propsAsIs: true
});
export const contentInnerContentClass = "c1opjy5t";
export const Section = /*#__PURE__*/styled('div')({
  name: "Section",
  class: "s1ii0m18",
  propsAsIs: false
});
export const SectionTitle = /*#__PURE__*/styled('h2')({
  name: "SectionTitle",
  class: "s1wqnq4y",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => FontAwesomeIcon;
export const SectionTitleIconBase = /*#__PURE__*/styled(_exp7())({
  name: "SectionTitleIconBase",
  class: "siot9rg",
  propsAsIs: true
});
export const sectionTitleIconGoodClass = "s16mvc2o";
export const sectionTitleIconBadClass = "s17o8k6";
const _exp9 = /*#__PURE__*/() => ShinyBorderCard;
export const ListContainerRaw = /*#__PURE__*/styled(_exp9())({
  name: "ListContainerRaw",
  class: "l1y8wlx5",
  propsAsIs: true
});
export const listContainerInnerContentClass = "llekwlv";
export function ListContainer({
  children
}: {
  readonly children: React.ReactNode;
}) {
  return <ListContainerRaw innerClassName={listContainerInnerContentClass}>
		{children}
	</ListContainerRaw>;
}
const _exp1 = /*#__PURE__*/() => Section;
export const LongSection = /*#__PURE__*/styled(_exp1())({
  name: "LongSection",
  class: "l1iamsp9",
  propsAsIs: true
});
export const WorkList = /*#__PURE__*/styled('ul')({
  name: "WorkList",
  class: "wil72r8",
  propsAsIs: false
});
export const StrengthsGrid = /*#__PURE__*/styled('div')({
  name: "StrengthsGrid",
  class: "s1qpx66z",
  propsAsIs: false
});
export const StrengthCard = /*#__PURE__*/styled('div')({
  name: "StrengthCard",
  class: "s1ic4vps",
  propsAsIs: false
});
const _exp14 = /*#__PURE__*/() => Section;
export const ResumeSectionContainer = /*#__PURE__*/styled(_exp14())({
  name: "ResumeSectionContainer",
  class: "r1jy57ej",
  propsAsIs: true
});
const _exp15 = /*#__PURE__*/() => Section;
export const ResumeSection = /*#__PURE__*/styled(_exp15())({
  name: "ResumeSection",
  class: "rdi2tmj",
  propsAsIs: true
});
export const ResumeContainer = /*#__PURE__*/styled('div')({
  name: "ResumeContainer",
  class: "r4xrv77",
  propsAsIs: false
});
export const ResumeDescription = /*#__PURE__*/styled('p')({
  name: "ResumeDescription",
  class: "ro0sfnp",
  propsAsIs: false
});
export const PdfContainer = /*#__PURE__*/styled('div')({
  name: "PdfContainer",
  class: "pkws5nn",
  propsAsIs: false
});
export const PdfViewer = /*#__PURE__*/styled('iframe')({
  name: "PdfViewer",
  class: "p14gduiy",
  propsAsIs: false
});
const _exp17 = /*#__PURE__*/() => PrimaryLinkButton3Resume;
const DownloadResumeButtonUnderlyingLink = /*#__PURE__*/styled(_exp17())({
  name: "DownloadResumeButtonUnderlyingLink",
  class: "dftmfba",
  propsAsIs: true
});
const _exp18 = /*#__PURE__*/() => PDFDownloadButtonBorder;
const DownloadResumeButtonBorder = /*#__PURE__*/styled(_exp18())({
  name: "DownloadResumeButtonBorder",
  class: "d3dpin1",
  propsAsIs: true
});
export function DownloadResumeButton({
  children,
  ...props
}: React.ComponentPropsWithoutRef<'a'>) {
  return <DownloadResumeButtonBorder>
		<DownloadResumeButtonUnderlyingLink {...props}>
			{children}
		</DownloadResumeButtonUnderlyingLink>
	</DownloadResumeButtonBorder>;
}